import Axios from 'axios';
import Vue from 'vue';
import ChartDoughnut from "../../components/ChartDoughnut/studentChartDoughnut.vue";
import ChartBar1 from "../../components/ChartBar/ChartBar1.vue";

export default Vue.extend({
    

    components: {   
        ChartDoughnut,
        ChartBar1,
      },

    data: () => ({
        location : '',
        candidate_details:[],
        languages : '',
        technical_skills :[],
        // job_details : [],
        cards : [],
       
        grad_year : '',
        avgScore : 0,
        examAttemted:0,
        num_subject:0,
        attemptedDetails : [],
        thisMonthScores : [],
        allsubName : [],
        total_right : 0,
        total_wrong : 0,
        not_attempt : 0,
        is_data_fetched: false,
        dataLoading : false,
        page_define : 0,
        
    }),
    
    created(){
        this.candidate_id = this.$route.params.id;
        this.profileall_details();
        this.test_id = this.$route.params;
        this.page_define = this.test_id.test;
        console.log("enterbjhgh", this.page_define);
        localStorage.setItem("page_define",this.page_define);
    
    },
    
  
    methods:{
        async profileall_details(){
            let token =  localStorage.getItem("jwt");
            this.dataLoading = true;
            if (token) { 
                const auth = {
                    headers: {authorization: token} 
                }  
                let result = await this.$http.get('/profile/fetchStudentProfile/'+this.candidate_id, auth)
                let dataresult = await this.$http.get('/student/studentDashboardInfo/'+this.candidate_id, auth)
                    
                console.log("dataresult",dataresult);
                console.log("candidate",result.data);
                if (result.status=== 200 && result.data.message === "Student found" && dataresult.status===200){
                    this.candidate_details = result.data.student;
                    if (result.data.student.tech_skills.length>0) {
                        result.data.student.tech_skills.forEach(element => {
                            this.technical_skills.push(element.skills_name);
                        });
                    }
                                    
                    this.avgScore =  dataresult.data.data.average_score;
                    this.num_subject =  dataresult.data.data.number_of_subjects;
                 
                    this.examAttemted = dataresult.data.data.total_exams_given;
                    this.attemptedDetails = dataresult.data.data.subject_details;

                    this.total_right = dataresult.data.data.total_correct_answers;
                    this.total_wrong = dataresult.data.data.total_incorrect_answers;
                    this.not_attempt = dataresult.data.data.total_questions_unattempted;
                    this.is_data_fetched=true;
                   
                        
                    for (let i = 0; i < dataresult.data.data.current_month_scores.length; i++) {
                        this.thisMonthScores.push(dataresult.data.data.current_month_scores[i].average_marks_scored);
                        this.allsubName.push(dataresult.data.data.current_month_scores[i].subject_name);
                    }
                }

                    this.cards = [
                        { title: 'No. of Subjects', value: this.num_subject, icon: 'mdi-account' },
                        { title: 'Exam Taken', value: this.examAttemted, icon: 'mdi-pencil' },
                        { title: 'Average Score', value: this.avgScore.toFixed(2), icon: 'mdi-book'  },
                    ]
                    this.dataLoading = false;
            }
        },

        backPage() {
            window.history.back()
        },

      
    }
   
})